import { render, staticRenderFns } from "./SharedRoomConsultationsInWard.vue?vue&type=template&id=cc24d8a0&scoped=true&"
import script from "./SharedRoomConsultationsInWard.vue?vue&type=script&lang=js&"
export * from "./SharedRoomConsultationsInWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc24d8a0",
  null
  
)

export default component.exports